import { OBTENER_COLA, OBTENER_AREAS, VALIDAR_AREA, AGENTE_LOGOUT, ACTUALIZAR_LISTA, VALIDAR_AGENTE, SESION_AGENTE, OBTENER_URL_SERVICIO, VALIDAR_USUARIO, SELECCIONAR_ROL, TRAER_SERVICIOS, SESION_AREA } from "../constants/action-types"
import axios from "axios";

export function validarUsuario(identificacion) {
    return async function (dispatch) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/traerUsuario/" + identificacion);
            dispatch({ type: VALIDAR_USUARIO, payload: await response.data });
        } catch (error) {
            dispatch({ type: VALIDAR_USUARIO, payload: await error.response.data });
        }
    }
}

export function validarArea(datos) {
    return async function (dispatch) {
        try {
            const response = await axios.post(OBTENER_URL_SERVICIO + "/loginArea", datos);
            dispatch({ type: VALIDAR_AREA, payload: await response.data });
        } catch (error) {
            dispatch({ type: VALIDAR_AREA, payload: await error.response.data });
        }
    }
}

export function obtenerAreas() {
    return async function (dispatch) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/areas");
            dispatch({ type: OBTENER_AREAS, payload: await response.data });
        } catch (error) {
            dispatch({ type: OBTENER_AREAS, payload: await error.response.data });
        }
    }
}

export function sesionArea(area) {
    return async function (dispatch) {
        dispatch({ type: SESION_AREA, payload: area });
    }
}


export function seleccionarRol(rol) {
    return async function (dispatch) {
        try {
            dispatch({ type: SELECCIONAR_ROL, payload: rol });
        } catch (error) {
            dispatch({ type: SELECCIONAR_ROL, payload: rol });
        }
    }
}

export function traerServicios(rol, codPrograma, idArea) {
    return async function (dispatch) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/serviciosPR/" + rol + "/" + codPrograma + "/" + idArea);
            dispatch({ type: TRAER_SERVICIOS, payload: await response.data });
        } catch (error) {
            dispatch({ type: TRAER_SERVICIOS, payload: await error.response.data });
        }
    }
}


export function validarAgente(correo) {
    return async function (dispatch) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/clienteCorreo/" + correo);
            dispatch({ type: VALIDAR_AGENTE, payload: await response.data });
        } catch (error) {
            dispatch({ type: VALIDAR_AGENTE, payload: await error.response.data });
        }
    }
}


export function sesionAgente(agente) {
    return async function (dispatch) {
        dispatch({ type: SESION_AGENTE, payload: agente });
    }
}

export function actualizarLista(rol, codPrograma, idServicio, idArea) {
    return async function (dispatch) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/serviciosSecA/" + rol + "/" + codPrograma + "/" + idServicio + "/" + idArea);
            dispatch({ type: ACTUALIZAR_LISTA, payload: await response.data });
        } catch (error) {
            dispatch({ type: ACTUALIZAR_LISTA, payload: await error.response.data });
        }
    }
}

export function obtenerCola(idCola) {
    return async function (dispatch) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/colaPantalla/"+idCola);
            dispatch({ type: OBTENER_COLA, payload: await response.data });
        } catch (error) {
            dispatch({ type: OBTENER_COLA, payload: await error.response.data });
        }
    }
}

export function logout() {
    return function (dispatch) {
        dispatch({ type: AGENTE_LOGOUT, payload: "" })
    }
}
